import { MdAnnouncement } from "react-icons/md";
import Modal from "react-responsive-modal";

import {
  Content,
  ButtonsContainer,
  ConfirmButton,
  CancelButton,
} from "./styles";

interface IModalRemoveTemplate {
  open: boolean;
  onRemoveTemplate(): void;
  removingTemplate: boolean;
  onClose(): void;
}

export default function ModalRemoveTemplate({
  open,
  onRemoveTemplate,
  removingTemplate,
  onClose,
}: IModalRemoveTemplate) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      classNames={{
        modal: "remove-photo-modal",
      }}
    >
      <Content>
        <MdAnnouncement size={40} color="#666666" />

        <p>Tem certeza que deseja remover esse modelo?</p>

        <ButtonsContainer>
          <ConfirmButton onClick={onRemoveTemplate}>
            {removingTemplate ? "Removendo..." : "Sim"}
          </ConfirmButton>
          <CancelButton onClick={onClose}>Não</CancelButton>
        </ButtonsContainer>
      </Content>
    </Modal>
  );
}
